// styles.js
import { styled } from '@mui/material/styles';
import {
  DialogContent,
  DialogActions,
  Button,
  TableContainer,
  DialogTitle
} from '@mui/material';


// Styled component for the root div
export const RootDiv = styled('div')(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
}));

// Header styles
export const Header = styled('div')(({ theme }) => ({
  textAlign: 'center',
  height: '3rem',
  padding: '0rem 11.25rem',
  gap: '1.5rem',
  display: 'flex',
  alignItems: 'center',
  borderBottom: '1px solid #E0E0E0',
  [theme.breakpoints.down('sm')]: {
    padding: '0rem 1rem',
    flexWrap: 'wrap',
    height: 'auto',
    gap: '0.5rem',
  },
}));

export const LogoContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  [theme.breakpoints.down('sm')]: {

    justifyContent: 'center',
  },
}));

export const Logo = styled('img')({
  height: '1.45rem',
});

export const Title = styled('span')({
  color: '#161616',
  fontFamily: 'Inter, sans-serif',
  fontSize: '1.1875rem',
  fontWeight: 600,
  lineHeight: '1.25rem',
  letterSpacing: '-0.03125rem',
  marginLeft: '0.5rem',
});

// Search container
export const SearchContainer = styled('div')(({ theme, showSearch }) => ({
  display: 'flex',
  justifyContent: 'flex-end',
  alignItems: 'center',
  flex: '1 0 0',
  [theme.breakpoints.down('sm')]: {
    width: '100%',
    justifyContent: showSearch ? 'center' : 'flex-end',
  },
}));

// Content container
export const ContentContainer = styled('div')(({ theme }) => ({
  padding: '0rem 11.25rem',
  [theme.breakpoints.down('sm')]: {
    padding: '0rem 1rem',
  },
}));

// Page header styles
export const PageHeader = styled('div')({
  justifyContent: 'space-between',
  display: 'flex',
  alignItems: 'center',
  margin: '2rem 0',
});

export const PageTitle = styled('span')({
  fontFamily: "'Inter', sans-serif",
  fontSize: '1.25rem',
  fontWeight: 700,
  lineHeight: '1.75rem',
});

// Create button styles
export const CreateButton = styled(Button)({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  background: '#F03D00',
  borderRadius: '0px',
  padding: '0.875rem 1rem',
  gap: '0.5rem',
  textTransform: 'none',
  '&:hover': {
    backgroundColor: '#d83600',
  },
});

export const CreateButtonText = styled('span')({
  fontFamily: "'Roboto', sans-serif",
  fontSize: '1rem',
  fontWeight: 700,
  lineHeight: '1.25rem',
});

//Instruction container styles
export const InstructionContainer = styled('div')({
    display: 'flex',
    padding: '1rem',
    alignItems: 'flex-end',
    background: '#F4F4F4',
    color: '#161616',
    fontFamily: "'Roboto', sans-serif",
    fontSize: '1rem',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '1.375rem',
    letterSpacing: '0.009375rem',
    marginBottom: '1rem',
});

// Table container styles
export const TableContainerStyled = styled(TableContainer)(({ theme }) => ({
  backgroundColor: '#F4F4F4',
  margin: 'auto',
  overflowX: 'auto',
}));

// Dialog styles
export const DialogPaper = styled('div')(() => ({}));

export const DialogTitleStyled = styled(DialogTitle)(({ theme }) => ({
  height: '3.25rem',
  backgroundColor: 'white',
  padding: '1rem',
  color: '#161616',
  fontSize: '1.25rem',
  fontFamily: 'Inter, sans-serif',
  fontWeight: 700,
  lineHeight: '1.75rem',
  display: 'flex',
  alignItems: 'center',
  [theme.breakpoints.down('sm')]: {
    fontSize: '1rem',
    padding: '0.5rem',
  },
}));

export const DialogContentStyled = styled(DialogContent)(({ theme }) => ({
  paddingTop: '0.5rem',
  paddingBottom: '1.25rem',
  paddingLeft: '1rem',
  paddingRight: '1rem',
  backgroundColor: 'white',
  display: 'flex',
  flexDirection: 'column',
  gap: '1rem',
  [theme.breakpoints.down('sm')]: {
    paddingLeft: '0.5rem',
    paddingRight: '0.5rem',
  },
}));

export const DialogActionsStyled = styled(DialogActions)(({ theme }) => ({
  padding: '1rem',
  backgroundColor: 'white',
  borderRadius: '0.125rem',
  display: 'flex',
  justifyContent: 'flex-end',
  gap: '1rem',
  [theme.breakpoints.down('sm')]: {
    padding: '0.5rem',
    gap: '0.5rem',
  },
}));

export const ResponsiveButton = styled(Button)(({ theme }) => ({
  paddingLeft: '1rem',
  paddingRight: '1rem',
  paddingTop: '0.8125rem',
  paddingBottom: '0.8125rem',
  borderRadius: '0.125rem',
  fontSize: '1rem',
  fontFamily: 'Roboto, sans-serif',
  fontWeight: 700,
  lineHeight: '1.25rem',
  textTransform: 'none',
  '&:hover': {
    backgroundColor: theme.palette.action.hover,
  },
  [theme.breakpoints.down('sm')]: {
    paddingLeft: '0.5rem',
    paddingRight: '0.5rem',
    paddingTop: '0.5rem',
    paddingBottom: '0.5rem',
    fontSize: '0.875rem',
  },
}));

// Icon button group
export const IconButtonGroup = styled('div')({
  display: 'flex',
});

export const CloseButton = styled('div')({
  position: 'absolute',
  right: '1rem',
});